// extracted by mini-css-extract-plugin
export var dropdownIcon = "_o2-6";
export var imgContainer = "_o2-3";
export var menuIcon = "_o2-5";
export var pillWrapper = "_o2-2";
export var pillsContainer = "_o2-1";
export var subscriptionCard = "_o2-0";
export var subscriptionLogo = "_o2-4";